import * as React from 'react';
import { st, classes } from './LikeButton.st.css';
import { LikeHeart, LikeHeartFill } from '@wix/wix-ui-icons-common/on-stage';
import { IconToggle, IconToggleLabelPlacement } from '../IconToggle';
import { LikeButtonProps, LikeButtonDefaultProps } from './types';

export class LikeButton extends React.Component<LikeButtonProps> {
  static displayName = 'LikeButton';
  static defaultProps: LikeButtonDefaultProps = {
    label: '',
    labelPlacement: IconToggleLabelPlacement.END,
    checked: false,
    disabled: false,
  };

  render() {
    const { label, labelPlacement, onChange, checked, disabled, className } =
      this.props;

    return (
      <div className={classes.likeButton}>
        <IconToggle
          className={st(classes.root, { checked, disabled }, className)}
          icon={<LikeHeart />}
          checkedIcon={<LikeHeartFill />}
          label={label}
          disabled={disabled}
          onChange={onChange}
          checked={checked}
          labelPlacement={labelPlacement}
          animation
          data-hook={this.props['data-hook']}
        />
      </div>
    );
  }
}
